import { render, staticRenderFns } from "./WhyUse.vue?vue&type=template&id=30b2114a&scoped=true&"
import script from "./WhyUse.vue?vue&type=script&lang=js&"
export * from "./WhyUse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b2114a",
  null
  
)

export default component.exports